import { memo, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import config from "../../../config/app-config";

import { Box, Flex, Menu, MenuButton, MenuList, MenuItem, Button, useToast } from '@chakra-ui/react'
import { updateDsr, resetUpdateDsrOutcome } from '../actions/dsr-actions';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { checkIfInteger, displayMoney, getThisUserIdToken, openInNewTab, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { IoChevronDownOutline } from 'react-icons/io5';
import { SiBrandfolder } from 'react-icons/si'
import { AiOutlineIdcard } from 'react-icons/ai'
import LaunchdeckSwitch from '../../global/components/helper-components/components/LaunchdeckSwitch'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal';
import PlainFormTextInput from '../../forms/TextInputField/components/PlainFormTextInput';

function DsrRoomSettingsPage({
  // Parent component
  dsrId,
  dsrProperties,
  // Actions
  updateDsr,
  resetUpdateDsrOutcome,
  // Redux state
  isMobileView,
  dsrStatusRedux,
  updateDsrOutcome,
  dsrBrandingOptions,
  isArchivedDsr
}) {

  const toast = useToast();
  const { openLaunchdeckModal } = useLaunchdeckModal();

  const [editCurrencyValueMode, setEditCurrencyValueMode] = useState(false)
  const [logoDisplayMode, setLogoDisplayMode] = useState("")
  const [latestDsrProperties, setLatestDsrProperties] = useState("")
  const [applyBranding, setApplyBranding] = useState(null)

  const { dealValue } = latestDsrProperties || {};
  const { currency, numberValue } = dealValue || {};
  const displayedDealValue = numberValue ? displayMoney("", numberValue) : "-" // Display without currency
  const currencyValueRef = useRef(null);
  const scrollToRef = useRef(false);



  useEffect(() => {
    if (dsrProperties) {
      setLatestDsrProperties(dsrProperties)
      setLogoDisplayMode(dsrProperties.logoDisplayOption ? dsrProperties.logoDisplayOption : "default")

      const { applyBranding } = dsrProperties || {};
      setApplyBranding(applyBranding)
    }
  }, [dsrProperties]);

  useEffect(() => {
    if (scrollToRef.current) {
      const elementPosition = scrollToRef.current.getBoundingClientRect().top;
      const offset = 200; // Offset (200px)

      window.scrollTo({
        top: elementPosition - offset, // Scroll to the position minus the offset
        // behavior: 'smooth',
      });
    }
  }, []);

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus, sourceEvent
        // updatedDsrId, 
      } = updateDsrOutcome || {};

      switch (sourceEvent) {
        case ("save-room-properties"): {
          if (!updateDsrStatus) {
            toast(
              triggerLaunchdeckToast({
                useCase: "show-error-state",
                label: "Unfortunately something went wrong. Please try again later.",
                isMobileView
              })
            )
          }

          resetUpdateDsrOutcome()
          break;
        }
        default: {
          console.log(`There is no such sourceEvent: ${sourceEvent}`)
          break;
        }
      }
    }
  }, [updateDsrOutcome, toast, dsrId, resetUpdateDsrOutcome, isMobileView]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if ((editCurrencyValueMode && currencyValueRef.current) && !currencyValueRef?.current.contains(event.target)) {
        setEditCurrencyValueMode(false);
        handleSaveDsrProperties();
      }
    };

    if (editCurrencyValueMode) {
      setTimeout(() => window.addEventListener('mousedown', handleClickOutside), 100)
    } else {
      window.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [editCurrencyValueMode, latestDsrProperties]);

  const onChangeHandler = event => {
    switch (event.target.name) {
      case ('dealValue'): {
        const { checkedValue, isInteger } = checkIfInteger(event.target.value)

        if (!!isInteger) {
          const updatedDsrProperties = {
            ...latestDsrProperties,
            dealValue: {
              ...dealValue,
              numberValue: parseInt(checkedValue)
            }
          }

          setLatestDsrProperties(updatedDsrProperties)
        }

        break;
      }
      default: {
        break;
      }
    }
  };

  const handleSaveDsrProperties = () => {
    if (dsrId) {
      updateDsr({
        dsrId: dsrId,
        dsrProperties: latestDsrProperties,
        sourceEvent: "save-room-properties"
      })
    }
  }

  const handleSaveRoomSettings = (mode, changedValue) => {
    let updatedDsrProperties = "";
    let instantSave = false;

    switch (mode) {
      case ("currency"): {
        const { currency } = changedValue || {}
        if (currency) {
          updatedDsrProperties = {
            ...latestDsrProperties,
            dealValue: {
              ...dealValue,
              currency: currency
            }
          }

          instantSave = true;
        }


        break;
      }
      case ("room-value"): {
        const { numberValue } = changedValue || {}
        if (numberValue) {
          updatedDsrProperties = {
            ...latestDsrProperties,
            dealValue: {
              ...dealValue,
              numberValue: parseInt(numberValue)
            }
          }

          instantSave = false; // Don't autosave since it depends on clicking outside
        }

        break;
      }
      case ("logo-display-option"): {
        const { option } = changedValue || {}
        if (option) {
          updatedDsrProperties = {
            ...latestDsrProperties,
            logoDisplayOption: option
          }

          instantSave = true;
        }
        break;
      }
      case ("apply-room-branding"): {
        updatedDsrProperties = {
          ...latestDsrProperties,
          applyBranding: !applyBranding,
          orgBrandOwnerUserId: (applyBranding === false) ? getThisUserIdToken() : "" // Inverse logic since setting the value comes later
        }

        setApplyBranding(!applyBranding)
        instantSave = true;

        break;
      }
      default: {
        break;
      }
    }

    updatedDsrProperties && setLatestDsrProperties(updatedDsrProperties)

    if (dsrId && !!instantSave) {
      updateDsr({
        dsrId: dsrId,
        dsrProperties: updatedDsrProperties,
        sourceEvent: "save-room-properties"
      })
    }
  }

  if (isArchivedDsr) {
    return (
      <>
        <Flex justify='space-between' align='center'>
          <Box ref={scrollToRef}>
            <Box color='brandDark.500' fontSize='1.5em' lineHeight='1.4em' fontWeight='600'>Archived Room Settings</Box>
            <Box color='brandDark.500' fontSize={['0.75em', '0.75em', '0.875em', '0.875em']} fontWeight='400'>
              Configure how your Room should behave
            </Box>
          </Box>
        </Flex>

        <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>

          <Box fontSize={['0.8em', '1em']} fontWeight='600' letterSpacing='1px' textTransform='uppercase' color='brand.500' mb='1em'>Unarchive Room</Box>

          <Flex w='100%' py='1.5em' justify={['flex-start', 'space-between']} align={['flex-start', 'center']} direction={['column', 'row']} gap='0.5em'>
            <Box>
              <Box lineHeight='1.25em' fontWeight='500'>
                Revert back to draft state
              </Box>
              {dsrStatusRedux === "active" ?
                <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em' pr='2em'>
                  Content is retained, members will be unable to access the Room until you re-publish it again
                </Box> :
                <Flex fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                  Room is currently <span><Box color='brandDark.500' fontWeight='600' pl='0.25em'> archived</Box></span>
                </Flex>}
            </Box>


            <LaunchdeckButton bg='brandDark.500' color='white' fontSize='0.8em' onClick={() => {
              openLaunchdeckModal('revert-dsr-to-draft')
            }} label='Unarchive' />
          </Flex>
        </Box>

        <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
          <Box fontSize={['0.8em', '1em']} fontWeight='600' letterSpacing='1px' textTransform='uppercase' color='brandPink.500'
            mb='1em'>Danger Zone</Box>

          <Flex w='100%' py='1.5em' justify={['flex-start', 'space-between']} align={['flex-start', 'center']} direction={['column', 'row']} gap='0.5em'>
            <Box>
              <Box lineHeight='1.25em' fontWeight='500'>
                Delete this Room
              </Box>
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                Room content & members will be removed. This action cannot be undone.
              </Box>
            </Box>


            <LaunchdeckButton bg='gray.100' color='#DA3739' fontSize='0.8em' onClick={() => {
              openLaunchdeckModal('delete-dsr')
            }} label='Delete' />
          </Flex>
        </Box>
      </>
    )
  } else return (
    <Box>
      <Flex justify='space-between' align='center'>
        <Box ref={scrollToRef}>
          <Box color='brandDark.500' fontSize='1.5em' lineHeight='1.4em' fontWeight='600'>Room Settings</Box>
          <Box color='brandDark.500' fontSize={['0.75em', '0.75em', '0.875em', '0.875em']} fontWeight='400'>
            Configure how your Room should behave
          </Box>
        </Box>
      </Flex>

      {/* <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' mt='1.5em'>

        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em'>Client Info</Box>

        <Flex w='100%' justify='flex-start' align='center'>
          <Box lineHeight='1.275em' fontWeight='500' my='1em' fontSize='0.875em'>
            Client name
          </Box>
        </Flex>

        <PlainFormTextInput
          name={'clientName'}
          onChange={onChangeHandler}
          defaultValue={clientName}
          mb='0em'
          mt='0em'
        />

        <Flex w='100%' justify='flex-start' align='center'>
          <Box lineHeight='1.275em' fontWeight='500' my='1em' fontSize='0.875em'>
            Client website
          </Box>

        </Flex>

        <PlainFormTextInput
          name={'clientWebsiteUrl'}
          onChange={onChangeHandler}
          defaultValue={clientWebsiteUrl}
          // color={textColor}
          mb='0em'
          mt='0em'
        />


        <Flex w='100%' justify='flex-end' mt='2em'>
          <LaunchdeckButton bg='brand.500' color='white' onClick={() => handleSaveDsrProperties()} label='Save' />
        </Flex>
      </Box> */}

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>

        <Box fontSize={['0.8em', '1em']} fontWeight='600' letterSpacing='1px' textTransform='uppercase' color='brand.500'
          mb='1em'>Display options</Box>

        {!isMobileView &&
          <>
            <Flex w='100%' justify='space-between' align='center' py='1.5em'>
              <Box>
                <Box lineHeight='1.25em' fontWeight='500'>
                  Logo display
                </Box>
                <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                  Customise how logos are displayed
                </Box>
              </Box>
            </Flex>

            <Flex w='100%' p='0.5em'>
              <Flex w='100%' gap={8} direction={['column', 'row']}>
                <Box flex='1' border={logoDisplayMode === "default" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "default" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "default" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                  onClick={() => {
                    if (logoDisplayMode !== "default") {
                      handleSaveRoomSettings("logo-display-option", { option: "default" });
                      setLogoDisplayMode("default");
                    }
                  }
                  }
                  transition='all 0.1s ease-in-out'
                  justifyItems='center'
                >
                  <Flex w='3em' h='3em' justify='center' align='center'>
                    <Box as={SiBrandfolder} boxSize='1em' />
                  </Flex>

                  <Box fontSize='0.8em' mt='1em'>Normal size</Box>
                </Box>

                <Box flex='1' border={logoDisplayMode === "large-logos" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "large-logos" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "large-logos" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                  onClick={() => {
                    if (logoDisplayMode !== "large-logos") {
                      handleSaveRoomSettings("logo-display-option", { option: "large-logos" });
                      setLogoDisplayMode("large-logos");
                    }
                  }
                  }
                  transition='all 0.1s ease-in-out'
                  justifyItems='center'
                >
                  <Flex w='3em' h='3em' justify='center' align='center'>
                    <Box as={SiBrandfolder} boxSize='2em' />
                  </Flex>
                  <Box fontSize='0.8em' mt='1em'>Larger logos</Box>
                </Box>

                <Box flex='1' border={logoDisplayMode === "nametag" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "nametag" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "nametag" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                  onClick={() => {
                    if (logoDisplayMode !== "nametag") {
                      handleSaveRoomSettings("logo-display-option", { option: "nametag" });
                      setLogoDisplayMode("nametag");
                    }
                  }
                  }
                  transition='all 0.1s ease-in-out'
                  justifyItems='center'
                >
                  <Flex w='3em' h='3em' justify='center' align='center'>
                    <Box as={AiOutlineIdcard} boxSize='1.5em' />
                  </Flex>
                  <Box fontSize='0.8em' mt='1em'>Nametag</Box>
                </Box>
              </Flex>
            </Flex>
          </>
        }


        <Flex w='100%' py='1.5em' justify={['flex-start', 'space-between']} align={['flex-start', 'center']} direction={['column', 'row']} gap='0.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Branding colors
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Apply Room owner's brand colors
            </Box>
          </Box>

          <Flex pr='0.5em'>
            {dsrBrandingOptions ?
              <LaunchdeckSwitch
                name="applyRoomBranding"
                isChecked={applyBranding}
                onChange={() => handleSaveRoomSettings("apply-room-branding", {})}
                yesContent='"On"'
                noContent='"Off"'
                yesBg="brandDark.500"
                noBg=""
              />
              :
              <LaunchdeckButton onClick={() => openInNewTab(`${config.displayUrl}/profile?section=set-brand-colors`)} bg='gray.100' color='brandDark.500' label='Not set' />
            }

          </Flex>

        </Flex>

        <Flex w='100%' py='1.5em' justify={['flex-start', 'space-between']} align={['flex-start', 'center']} direction={['column', 'row']} gap='0.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Page content
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Choose whether to hide or lock your pages
            </Box>
          </Box>
          <Box mt={['0', '1em']}>
            <LaunchdeckButton bg='brandDark.500' color='white' fontSize='0.8em' onClick={() => {
              openLaunchdeckModal('mass-manage-dsr-custom-pages')
            }} label='Manage pages' />
          </Box>
        </Flex>

      </Box>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' mt='1.5em'>
        <Box fontSize={['0.8em', '1em']} fontWeight='600' letterSpacing='1px' textTransform='uppercase' color='brand.500'
          mb='1em'>Organize</Box>

        <Box w='100%' my='1.5em'>

          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Deal Value
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Help your team set priorities
            </Box>
          </Box>


          <Flex my='1em' w='100%' justify='center' align='center'>
            <Menu mb='0em' fontSize={['0.8em', '0.875em']}>
              <MenuButton as={Button} rightIcon={<IoChevronDownOutline />} height='2.5em' fontSize={['0.8em', '0.875em']} lineHeight='1.275em'>
                <Box px='0.5em' fontSize={['0.8em', '0.875em']}>{currency ? currency : "USD"}</Box>
              </MenuButton>
              <MenuList fontSize={['0.8em', '0.875em']}>
                <MenuItem onClick={() => handleSaveRoomSettings('currency', { currency: 'USD' })}>{"USD"}</MenuItem>
                <MenuItem onClick={() => handleSaveRoomSettings('currency', { currency: 'GBP' })}>{"GBP"}</MenuItem>
                <MenuItem onClick={() => handleSaveRoomSettings('currency', { currency: 'EUR' })}>{"EUR"}</MenuItem>
                {/* // TODO: Allow custom input of 3 letter currency acronym */}
              </MenuList>
            </Menu>

            <Flex ref={currencyValueRef} w='100%' justify='flex-start'>
              {editCurrencyValueMode ?
                <PlainFormTextInput
                  name={'dealValue'}
                  type='number'
                  onChange={onChangeHandler}
                  defaultValue={numberValue}
                  mb='0em'
                  mt='0em'
                  w='100%'
                />
                :

                <Box as="div" ml='0.5em'
                  // minW='20em' 
                  w='100%'
                  maxW='20em'
                  cursor='pointer' onClick={() => {
                    setEditCurrencyValueMode(true)
                  }}> {displayedDealValue} </Box>

              }
            </Flex>
          </Flex>
        </Box>


      </Box>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>

        <Box fontSize={['0.8em', '1em']} fontWeight='600' letterSpacing='1px' textTransform='uppercase' color='brand.500'
          mb='1em'>Unpublish Room</Box>

        <Flex w='100%' py='1.5em' justify={['flex-start', 'space-between']} align={['flex-start', 'center']} direction={['column', 'row']} gap='0.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Revert back to draft state
            </Box>
            {dsrStatusRedux === "active" ?
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em' pr='2em'>
                Content is retained, members will be unable to access the Room until you re-publish it again
              </Box> :
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                Room is currently unpublished
              </Box>}
          </Box>

          {dsrStatusRedux === "active" ?

            <LaunchdeckButton bg='brandDark.500' color='white' fontSize='0.8em' onClick={() => {
              openLaunchdeckModal('revert-dsr-to-draft')
            }} label='Unpublish' />

            :

            <LaunchdeckButton dummy={true} bg='gray.100' color='gray.500' label='Unpublish' />

          }


        </Flex>
      </Box>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
        {/* <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Danger Zone</Box> */}
        <Box fontSize={['0.8em', '1em']} fontWeight='600' letterSpacing='1px' textTransform='uppercase' color='brandPink.500'
          mb='1em'>Danger Zone</Box>

        <Flex w='100%' py='1.5em' justify={['flex-start', 'space-between']} align={['flex-start', 'center']} direction={['column', 'row']} gap='0.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Delete this Room
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Room content & members will be removed. This action cannot be undone.
            </Box>
          </Box>


          <LaunchdeckButton bg='gray.100' color='#DA3739' fontSize='0.8em' onClick={() => {
            openLaunchdeckModal('delete-dsr')
          }} label='Delete' />
        </Flex>
      </Box>
    </Box >

  )

}

const mapStateToProps = (state) => {
  return {
    dsrStatusRedux: state.dsrStatus.status,
    updateDsrOutcome: state.updateDsrOutcome.results.data,
    dsrBrandingOptions: state.dsrBrandingOptions.results,
    isMobileView: state.mobileViewMode.isMobileView,
    isArchivedDsr: state.isArchivedDsr.results
  }
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      resetUpdateDsrOutcome
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrRoomSettingsPage)))
